import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import SectionTitle from '../project-manage/SectionTitle';
import Invitation from './Invitation';

export default function InvitationsInvited(props) {
  const { event, onViewMessages } = props;

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          response: 'Pending'
        }
      }
    },
    pagination: {
      pageSize: 100
    }
  });

  if (invitations.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (invitations.data.length === 0) {
    return null;
  }

  return (
    <SectionTitle
      title="Invited Partners"
      subtitle="These partners were invited but did not respond to the invitation."
    >
      <div className="grid grid-cols-1 gap-4">
        {invitations.data.map(function (invitation, index) {
          return (
            <Invitation
              key={invitation.id || invitation.cid}
              invitation={invitation}
              onViewMessages={onViewMessages}
            />
          );
        })}
      </div>
    </SectionTitle>
  );
};
